const USER_API = process.env.REACT_APP_USER_API;
const ACHIEVEMENT_API = process.env.REACT_APP_ACHIEVEMENT_API;
export  {USER_API, ACHIEVEMENT_API};